import Grid from '@mui/material/Grid';
import { FC, useEffect } from 'react';
import { EventsBreadCrumb } from '../components/events/EventsBreadCrumb';

const ContactPage: FC<any> = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <EventsBreadCrumb event={undefined} />
            <Grid container>

                <Grid size={{ md: 1, lg: 2, xl: 3 }}>

                </Grid>
                <Grid size={{ md: 10, lg: 8, xl: 6 }}>

                    Vill du komma i kontakt med mig? Skicka ett mail till <a href='mailto:fredrik@mindbound.se'>fredrik@mindbound.se</a>.
                </Grid>
                <Grid size={{ md: 1, lg: 2, xl: 3 }}>

                </Grid>
            </Grid>
        </>
    )

}


export default ContactPage;
